import styled from 'styled-components';
import { layout, LayoutProps, compose, BorderProps, MarginProps, PaddingProps, border, margin, padding } from 'styled-system';

interface SelectSubComponents {
  Options?: any;
}

type SelectProps = LayoutProps & BorderProps & MarginProps & PaddingProps;

const SelectStyle = styled.select<SelectProps>(compose(border, margin, padding, layout));
const Select: SelectSubComponents & typeof SelectStyle = SelectStyle;

Select.Options = styled.select<LayoutProps>(compose(layout));

Select.defaultProps = {
  borderColor: 'secondary.1',
  borderStyle: 'solid',
  borderWidth: '0px 0px 1px 0px',
};

export default Select;
